/**
 * Legacy OLS special-address tokens from GlobalConstants.SPECIAL_ADDRESS_KEYWORDS.
 * Matched case-insensitively against whole tokens in address line 1.
 */
export const SPECIAL_ADDRESS_KEYWORDS = [
  'po',
  'postal',
  'box',
  'general',
  'gd',
  'mr',
  'ss',
  'rr',
  'rural',
  'suburban',
  'bp',
  'boite',
  'boîte',
  'postale',
  'suburbain',
  'rurale',
] as const;

/**
 * Normalizes free-text address input into comparable lowercase tokens.
 */
function tokenizeAddressLine(value: string): string[] {
  return value
    .trim()
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s]/gu, ' ')
    .split(/\s+/)
    .filter((token) => token.length > 0);
}

/**
 * Returns true when address line 1 contains PO Box, Rural Route, or General Delivery keywords.
 * Mirrors legacy GlobalUtility.IsSpecialAddressString token matching on line 1 only.
 */
export function containsSpecialAddressKeywordInLine1(line1: string): boolean {
  const tokens = tokenizeAddressLine(line1);

  if (tokens.length === 0) {
    return false;
  }

  return tokens.some((token) =>
    SPECIAL_ADDRESS_KEYWORDS.some((keyword) => token === keyword.toLowerCase()),
  );
}
